import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { Markdown } from '../../components/Markdown';
import { ErrorNote, Spinner } from '../../components/ui';
import { Logo } from '../layout/Logo';

interface Doc { slug: string; title: string }

/** Public legal pages (no sign-in or site password needed). */
export function LegalPage() {
  const { slug } = useParams();
  const list = useQuery({ queryKey: ['legal'], queryFn: () => api<{ documents: Doc[] }>('/api/legal').then((r) => r.documents) });
  const doc = useQuery({ queryKey: ['legal', slug], queryFn: () => api<{ title: string; markdown: string }>(`/api/legal/${slug}`), enabled: !!slug });
  return (
    <div className="legal">
      <header className="legal__head"><Link to="/" className="legal__brand"><Logo /></Link></header>
      <div className="legal__layout">
        <nav className="legal__nav" aria-label="Legal documents">
          <strong>Legal</strong>
          {list.data?.map((d) => <Link key={d.slug} to={`/legal/${d.slug}`} className={d.slug === slug ? 'is-active' : ''}>{d.title}</Link>)}
        </nav>
        <main className="legal__doc">
          {!slug ? (
            <>
              <h1>Legal</h1>
              <p className="muted">The terms and policies that apply to Lumnos and to apps published with it.</p>
              <ul>{list.data?.map((d) => <li key={d.slug}><Link to={`/legal/${d.slug}`}>{d.title}</Link></li>)}</ul>
            </>
          ) : doc.isLoading ? <Spinner /> : doc.data ? <Markdown text={doc.data.markdown} /> : <ErrorNote error={doc.error} />}
        </main>
      </div>
    </div>
  );
}

/** Small row of legal links for footers. */
export function LegalLinks() {
  return (
    <p className="legal-links small muted">
      <Link to="/legal/terms">Terms</Link> · <Link to="/legal/privacy">Privacy</Link> · <Link to="/legal/acceptable-use">Acceptable use</Link> · <Link to="/legal">All policies</Link>
    </p>
  );
}
